import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=05b05c9a&scoped=true"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=05b05c9a&prod&lang=less&scoped=true"
import style1 from "./FloatingButton.vue?vue&type=style&index=1&id=05b05c9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b05c9a",
  null
  
)

export default component.exports